import { BaseModalController, IModal } from '../Modal'
import { ModalContext } from '../Modal'
import { createReactElement } from 'shared/utils/react.utils'
import {
    InactivityModal,
    InactivityModalMetaData,
} from 'Components/modal/InactivityModal/InactivityModal'

export class InactivityModalController
    extends BaseModalController<InactivityModalMetaData>
    implements IModal<InactivityModalMetaData>
{
    static Id = 'inactivity-modal' as const

    constructor(modalContext: ModalContext) {
        super(modalContext, InactivityModalController.Id)
    }

    createElement() {
        return createReactElement(InactivityModal, {
            getVisibility: this.getVisibility.bind(this),
            getMetaData: this.getMetaData as () => InactivityModalMetaData,
            onConfirm: this.handleConfirm.bind(this),
        })
    }

    private handleConfirm() {
        const metaData = this.getMetaData() as InactivityModalMetaData
        metaData.onConfirm?.()
        this.setVisibility(false)
    }
}
